import { apiClient } from "./apiClient";

export const API_THU_PATH = "thu"

export const thuApi = {
    SelectAll: () => apiClient.get(`${API_THU_PATH}`),
    SelectById: (id: number) => apiClient.get(`${API_THU_PATH}/${id}`)
};

